<template lang="pug">
.card.integration-card
  .header-row.d-flex.align-items-center.mb-2
    .logo-wrapper
      img.integration-logo(
        :alt='$t("integrations.logoAlt")'
        :src='integration.logo'
      )
    strong.title {{ integration.name }}

  p.description.mb-3 {{ integration.description }}

  icon.check-icon(name='check' v-if='integration.active')

  .footer-row.d-flex.align-items-center.justify-content-between
    button.btn.btn-outline-success.btn-configure(
      :disabled='integration.is_active'
      @click='configure(integration)'
    )
      | {{ $t('integrations.configureIntegration') }}

    button.btn.icon-only.btn-outline-danger(
      @click='deactivate(integration)'
      v-if='integration.active'
    )
      icon(name='plug-circle-xmark')
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';

export default {
  name: 'IntegrationCard',
  components: { Icon },
  props: {
    integration: {
      type: Object,
      required: true,
    },
  },
  methods: {
    configure(i) {
      this.$emit('configure', i);
    },
    deactivate(i) {
      this.$emit('deactivate', i);
    },
  },
};
</script>

<style scoped>
.integration-card {
  position: relative;
  width: 316px;
  min-height: 184px;
  padding: 16px;
  border: 1px solid #cccccc;
  border-radius: 10px;
  background-color: #ffffff;

  display: flex;
  flex-direction: column;
}

.header-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

.logo-wrapper {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.integration-logo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.title {
  margin: 0;
  font-size: 16px;
  color: #013d52;
}

.description {
  margin: 0 0 10px;
  font-size: 14px;
  color: #555555;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
}

.check-icon {
  position: absolute;
  top: 12px;
  right: 16px;
  width: 24px;
  height: 24px;
  background-color: #e6f4ea;
  color: #198754;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.footer-row {
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btn-configure {
  border: 1px solid #19665b;
  color: #19665b;
  background: transparent;
  border-radius: 10px;
  padding: 8px 16px;
  height: 37px;
  display: flex;
  align-items: center;
}

.btn-configure:disabled {
  background: #808080 !important;
  border-color: #808080 !important;
  color: #fff !important;
  cursor: not-allowed;
}

.icon-only {
  width: 37px;
  height: 37px;
  border: 1px solid #dc3545;
  color: #dc3545;
  background: transparent;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 8px;
}
</style>
